import { Injectable } from '@angular/core';
import { Activity } from '../../domain/activity';
import { Observable } from 'rxjs';
import { AbstractAppConfig } from '../../../app.config';
import { HttpClient } from '@angular/common/http';

// @dynamic
@Injectable()
export class ActivityService {
  static readonly DUMMY_CASE_REFERENCE = '0';
  static get ACTIVITY_VIEW() { return 'view'; }
  static get ACTIVITY_EDIT() { return 'edit'; }

  private userAuthorised;

  constructor(private httpClient: HttpClient, private appConfig: AbstractAppConfig) {}

  getActivities(...caseId: string[]): Observable<Activity[]> {
    const url = this.activityUrl() + `/cases/${caseId.join(',')}/activity`;
    return this.httpClient.get<Activity[]>(url);
  }

  postActivity(caseId: string, activityType: String): Observable<Activity[]> {
    const url = this.activityUrl() + `/cases/${caseId}/activity`;
    let body = { activity: activityType };
    return this.httpClient
      .post<Activity[]>(url, body);
  }

  verifyUserIsAuthorized(): void {
    if (this.activityUrl() && this.userAuthorised === undefined) {
      this.getActivities(ActivityService.DUMMY_CASE_REFERENCE).subscribe(
        _ => this.userAuthorised = true,
        error => {
            if (error.status === 403) {
              this.userAuthorised = false;
            } else {
              this.userAuthorised = true
            }
        }
      );
    }
  }

  private activityUrl(): string {
    return this.appConfig.getActivityUrl();
  }

  get isEnabled(): boolean {
    return this.activityUrl() && this.userAuthorised;
  }

}
